import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import * as requestFromServer from "./payrollApis";

// payroll -> get payroll api
export const getPayrollAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getPayroll(dataToBeSent);
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_PAYROLL_LIST, { payroll: response })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// payroll -> run payroll api
export const runPayrollAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.runPayroll(dataToBeSent);
    if (response) {
      setLoading(false);
      toastService.success(response?.message);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// payroll -> run payroll api
export const runManualPayrollAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.runManualPayroll(dataToBeSent);
    if (response) {
      setLoading(false);
      toastService.success(response?.message);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
